import dayjs from 'dayjs'
import {
  formatDate as format0,
  formatMoney as formatMoneyC,
} from 'common/helpers'

export const formatMoney= (n:number, zero?: string) => ((!!n) && ('number' === typeof n)) ? formatMoneyC(n, {cents: true}) : (zero || '--')
export const formatDate = (d:string) => (!!d) ? format0(d, 'third') : ' '

export const Dict: {
  [type:string]: string;
} = {
  "initial-drawdown": "Initial drawdown",
  "drawdown": "Drawdown",
  "repayment": "Repayment",

  "application-fee": "Application fee",
  "est-fee": "Establishment fee",
  "legal-fee": "Legal fee",
  "broker-fee": "Broker fee",
  "other-fee": "Other fee",
  "fee": "Line fee",

  "interest": "Interest",
  "default-interest": "Default interest",

  "gst": "Gst",
  "other": "Other",

  "Journal Default Interest Credit": "Journal Default Interest Credit",
  "Journal Credit": "Journal Credit",
  "Journal Debit": "Journal Debit",
}

export const cbFilterSchedule = (x:any) => (x.type?.toLocaleLowerCase().indexOf('journal') < 0)
export const cbFilterJournal  = (x:any) => (x.type?.toLocaleLowerCase().indexOf('journal') > -1)
// export const cbFilterLineFee  = (x:any) => (x.type?.toLocaleLowerCase().indexOf('fee') === 0 )
export const cbMap2Schedule = (x:any) => ({
  // ...x,
  reference: Dict[(x.type as string)] || x.type,
  date: dayjs(x.date).format('YYYY-MM-DD'),
  balance: x.balanceAfter,
  note: x.notes,
  debit: (x.value < 0) ? undefined : x.value,
  credit: (x.value < 0) ? (-1 * x.value) : undefined,
  hasTrans: !!x.transaction
})
export const cbMap2Journal = (x:any) => ({
  uuid: x.journalTransactionUuid,
  reference: x.type,
  date: dayjs(x.date).format('YYYY-MM-DD'),
  debit: (x.value < 0) ? undefined : x.value,
  credit: (x.value < 0) ? (-1 * x.value) : undefined,
  balance: x.balanceAfter,
  note: [x.comment, x.statementNote, x.notes, x.note].filter((x:string) => !!x).join('; '),
})
